// extracted by mini-css-extract-plugin
export default {"top":"SignIn_top__6yOSd","title":"SignIn_title__PkJy2","info":"SignIn_info__F-pyH","correct":"SignIn_correct__2Vydk"};